
import { useQuery } from '@tanstack/react-query';
import { useCurrentUser } from '@client/shared/auth';
import {
  BILLING_STATUS_QUERY_KEY,
  fetchBillingStatus,
  type BillingStatus,
} from './billing-operations.ts';

const DAY_MS = 86_400_000;

export function trialDaysLeft(status: Pick<BillingStatus, 'trialEndsAt'>): number {
  return Math.max(0, Math.ceil((new Date(status.trialEndsAt).getTime() - Date.now()) / DAY_MS));
}

type RefetchInterval =
  | number
  | false
  | ((query: { state: { data?: BillingStatus } }) => number | false);

export function useBillingStatus(options?: { refetchInterval?: RefetchInterval }) {
  const session = useCurrentUser();
  return useQuery({
    queryKey: BILLING_STATUS_QUERY_KEY,
    queryFn: fetchBillingStatus,
    enabled: session != null,
    staleTime: 60_000,
    refetchInterval: options?.refetchInterval ?? false,
  });
}

/** True when every slot of the group's effective listing cap is in use, so creating or
 *  unarchiving needs room. Fails open while loading or on error — the server enforces;
 *  this only drives affordances. */
export function useListingCapReached(): boolean {
  const { data } = useBillingStatus();
  return data != null && data.activeListings >= data.maxActiveListings;
}
